module.exports = __webpack_public_path__ + "static/img/order.9bdfdbbd.png";